import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Clock } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-228">
      {/* Background texture/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-barber-gray via-barber-black to-barber-black z-0" data-id="element-229"></div>

      {/* Subtle gold accent lines */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeInOut'
    }} className="absolute top-1/4 left-0 w-1/3 h-[1px] bg-gradient-to-r from-transparent to-barber-gold/30 z-0" data-id="element-230" />
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeInOut',
      delay: 0.2
    }} className="absolute bottom-1/4 right-0 w-1/3 h-[1px] bg-gradient-to-l from-transparent to-barber-gold/30 z-0" data-id="element-231" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-232">
        {/* Official VillaCon Barbershop Sign */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8 w-full max-w-3xl" data-id="element-233">
          <div className="w-full aspect-[9/16] max-h-[70vh] overflow-hidden rounded-sm shadow-[0_0_60px_rgba(212,168,83,0.2)]" data-id="element-234">
            <img src="https://cdn.magicpatterns.com/uploads/jRQNneGZyUBNEDyj77SHSE/villa_con_logo.png" alt="VillaCon Barbershop — Letrero oficial" className="w-full h-full object-cover" data-id="element-235" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-barber-text uppercase leading-[1.1] mb-8" data-id="element-236">
          {t('hero.tagline1')} <br data-id="element-237" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-barber-gold to-barber-goldHover" data-id="element-238">
            {t('hero.tagline2')}
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-12 text-barber-muted" data-id="element-239">
          <div className="flex items-center gap-2" data-id="element-240">
            <MapPin className="text-barber-gold" size={20} data-id="element-241" />
            <span data-id="element-242">{t('hero.address')}</span>
          </div>
          <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-barber-lightGray" data-id="element-243"></div>
          <div className="flex items-center gap-2 bg-barber-gold/10 px-4 py-1.5 rounded-full border border-barber-gold/20" data-id="element-244">
            <Clock className="text-barber-gold" size={20} data-id="element-245" />
            <span className="text-barber-gold font-bold tracking-wide" data-id="element-246">
              {t('hero.openUntil')}
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col w-full sm:w-auto gap-4" data-id="element-247">
          <a href="tel:3476058521" className="group relative inline-flex items-center justify-center gap-3 bg-barber-red hover:bg-barber-redHover text-white font-heading font-bold text-xl md:text-2xl tracking-wider px-8 py-5 rounded-sm transition-all overflow-hidden" data-id="element-248">
            <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-249"></div>
            <Phone className="animate-pulse" data-id="element-250" />
            {t('hero.cta')}
          </a>
          <p className="text-barber-muted text-sm uppercase tracking-widest mt-2" data-id="element-251">
            {t('hero.walkins')}
          </p>
        </motion.div>
      </div>
    </section>;
}